{
  "version": 1,
  "asset_id": "a0a1fffb-d2f0-43e7-bfff-a20c5c3df313",
  "project_id": "9fb22223-732b-4b0d-9eac-b115ce8cfd9c",
  "url": "/__l5e/assets-v1/a0a1fffb-d2f0-43e7-bfff-a20c5c3df313/cloudflare.svg",
  "r2_key": "a/v1/9fb22223-732b-4b0d-9eac-b115ce8cfd9c/a0a1fffb-d2f0-43e7-bfff-a20c5c3df313/cloudflare.svg",
  "original_filename": "cloudflare.svg",
  "size": 2461,
  "content_type": "image/svg+xml",
  "created_at": "2026-06-16T14:53:42Z"
}
